/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Grid, Divider } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import Components from "mpm-components";
import Assets from "mpm-assets";
import mpmServices from "mpm-services";
import * as Constants from 'mpm-config/Constants'
import { toClasses } from "class-converter";
import CessionCapture from "mpm-classes/CessionCapture";
import Utilities from "mpm-config/Utilities";
import MPMContext from "mpm-config/context/MPMContext";

const initial = {
    loading: true,
    data: undefined,
    statistics: undefined,
    error: false,
    autorized: false
};

const Block = ({menuCedant}) => {
    const [cessionCaptures, setCessionCaptures] = React.useState(initial);

    React.useEffect(() => {
        loadCessionsCaptures();
    }, []);

    const loadCessionsCaptures = () => {
        const promiseCCData = mpmServices.CessionsCaptureDataService.findAllPaginated(5, 0, {
            menuCedant
        });
        const promiseCCStatistics = mpmServices.CessionsCaptureDataService.statistic(menuCedant);
        Promise.all([promiseCCData, promiseCCStatistics])
            .then(([resultCCData, resultCCStatistics]) => {
                setCessionCaptures({
                    loading: false,
                    data: toClasses(resultCCData.data, CessionCapture),
                    statistics: Utilities.getCCStatistics(resultCCStatistics.data),
                    error: false,
                    autorized: true
                })
            }).catch(err => {
                setCessionCaptures({
                    loading: false,
                    data: [],
                    statistics: [],
                    error: true,
                    autorized: true
                })
            })
    }
    return (
        <Components.Regions.RegionWithHeader basic
        title={menuCedant ? "label.cedant.cedee" : "label.acquis"}
        headerColor="blue"
        headerSize="small"
        loading={cessionCaptures.loading}
        >
        <Grid stackable columns="2">
            <Grid.Column  mobile={16} computer={10} tablet={16}>
                    {
                        cessionCaptures.data &&
                        <Components.Tables.SmartTable header={[
                            {
                                selector: "numeroCessionComplet",
                                textAlign: "center",
                                label: (
                                    <FormattedMessage
                                        tagName="label"
                                        id="label.table.numero-cession"
                                    />
                                ),
                            },
                            {
                                selector: "dateCession",
                                textAlign: "center",
                                label: (
                                    <FormattedMessage
                                        tagName="label"
                                        id="label.table.date-cession"
                                    />
                                ),
                            },
                            {
                                selector: menuCedant ?  "cedantCCDTO.cedant" : "acquereurCCDTO.acquereur",
                                textAlign: "center",
                                label: (
                                    menuCedant ? <FormattedMessage
                                    tagName="label"
                                    id="label.cedant"
                                /> : <FormattedMessage
                                    tagName="label"
                                    id="label.table.acquereur"
                                />
                                    
                                ),
                            }, {
                                selector: "etat",
                                textAlign: "center",
                                label: (
                                    <FormattedMessage tagName="label" id="label.table.etat" />
                                ),
                                component: (row) => (
                                    <>{Utilities.getCessionCaptureEtatLabel(row.etat)}</>
                                ),
                            }]} data={cessionCaptures.data}
                            grouped={false}
                            striped={true}
                            pagination={false}
                            rowsPerPage={5} />
                    }
            </Grid.Column>
            <Grid.Column  mobile={16} computer={6} tablet={16}>
                {cessionCaptures.statistics && <Components.Statistics.Groupe items={cessionCaptures.statistics} size="small" />}
            </Grid.Column>
        </Grid>
        </Components.Regions.RegionWithHeader>
    )
}



export default () => {
    const context = React.useContext(MPMContext);
    const isAutorized = Utilities.isAutorizedUser(context.connectedUser, [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR])
    const isCedantAutorized = Utilities.isAutorizedUser(context.connectedUser, [Constants.ROLE_ADMIN, Constants.ROLE_ARMATEUR, Constants.ROLE_MAREYEUR]);
    const isAcquereurAutorized = Utilities.isAutorizedUser(context.connectedUser, [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR]);
 
    return (isAutorized && <Components.Regions.RegionWithHeader
        title="menu.cession.capture"
        headerColor="blue"
        headerSize="small"
        headerIconSrc={Assets.Images.cession_capture_header_icon}
        className="dash-region"
    >
        {isCedantAutorized && <Block menuCedant={true}  />}
        <Divider inverted/>
        {isAcquereurAutorized && <Block menuCedant={false}  />}
        </Components.Regions.RegionWithHeader>);
};


